const request = {
    invalid_input: "L'entrée est invalide. {{details}}",
    general: "Une erreur de requête s'est produite.",
    range_not_satisfiable: 'Plage non satisfaisable.',
    feature_not_supported: "Cette fonctionnalité n'est pas prise en charge dans l'environnement actuel.",
};
export default Object.freeze(request);
